<template>
  <div class="home">
    <div
      class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full"
      style="top: 50px"
    >
      <div class="flex px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">Leaderboards</div>
      </div>
      <div
        class="relative mx-12 border border-gray-300 focus:shadow-md focus:border-none flex-col rounded-full flex mb-6"
      >
        <input
          class="w-full leading-tight h-10 border-none px-4 bg-gray-200 focus:bg-white focus:outline-none rounded-full pl-10"
          v-model="quickSearch"
          placeholder="Search by Name, Email, or Phone number"
          type="text"
        />
        <div
          class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <svg
            class="fill-current pointer-events-none text-gray-600 w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="px-8">
      <table v-if="filteredRecords.length > 0" class="table-auto w-full">
        <thead>
          <tr>
            <th class="px-4 py-1 text-left">S/N</th>
            <th class="w-6/12 px-4 py-1 text-left">Leaderboard</th>
            <th class="w-2/12 px-4 py-1 text-left">Position</th>
            <th class="w-2/12 px-4 py-1 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in filteredRecords" :key="x">
            <td class="px-4 border-b py-5 text-left">{{ index + 1 }}</td>
            <td class="px-4 border-b py-5 text-left">{{ `${x.title}` }}</td>
            <td class="px-4 border-b py-5 text-left">
              {{ `${x.user_position}` }}
            </td>
            <td
              @click="navigate(x.id)"
              class="px-4 cursor-pointer border-b py-5 text-left"
            >
              View Details
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center text-2xl font-semibold text-black" v-else>
        No Records Found!
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      quickSearch: "",
      list: [],
    };
  },
  computed: {
    filteredRecords() {
      let data = this.list.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) > -1
          );
        });
      });

      return data;
    },
  },
  components: {
    card: () => import("@/components/tenant/reward-card"),
    lbutton: () => import("@/components/general/button"),
  },
  methods: {
    ...mapActions(["LearnerFetchLeaderboards"]),
    navigate(id) {
      this.$router.push({ name: "learner-leaderboard-single", params: { id } });
    },
  },
  async mounted() {
    let res = await this.LearnerFetchLeaderboards();
    this.list = res.data.data.leaderboards;
  },
};
</script>
